import Api from "./Api.service"
export default class CosaService {
    static ObtenerTodo() {
        return Api.get("cosa");
    }
    static Insertar(cosa) {
        return Api.post("cosa/insertar", cosa);
    }
    static Editar(cosa) {
        return Api.post("cosa/editar", cosa);
    }
    static Desactivar(cosa) {
        return Api.post("cosa/desactivar", cosa);
    }
}